namespace appn.views.repositoryAdmin.edit {

    class InitArgs {
        repositoryItemId: string = appn.emptyString;
    }

    let _initArgs: InitArgs;

    let _dataTable: any = null;

    export function init(args: InitArgs): void {
        _initArgs = args;
        createDataTable();
    }

    function createDataTable() {
        _dataTable = appn.dataTable.create('.dataTable', {
            sDom: appn.dataTable.genSDom(0, 0, 0), // sDom empty
            sAjaxSource: '../DataTableStoreItemInstalls',
            searching: false,
            fnServerData: function(data: any) {
                data.push({ name: 'sCustom_0', value: '' },
                    { name: 'sCustom_1', value: _initArgs.repositoryItemId },
                    { name: 'sCustom_2', value: '' });
            },
            aaSorting: [[1, 'desc']],
            aoColumns: [
                { bSortable: true, sWidth: '60%' },
                { bSortable: true, sWidth: '40%' }
            ]
        });
    }
}
